// test1250
(1250 && 0);
